import { render, staticRenderFns } from "./v-footer-contact-mobile-tab.vue?vue&type=template&id=900ae5b6&scoped=true&"
import script from "./v-footer-contact-mobile-tab.vue?vue&type=script&lang=js&"
export * from "./v-footer-contact-mobile-tab.vue?vue&type=script&lang=js&"
import style0 from "./v-footer-contact-mobile-tab.vue?vue&type=style&index=0&id=900ae5b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900ae5b6",
  null
  
)

export default component.exports